import { RequestResponseEvent } from '../interfaces';

export class Blacklist {
  static blacklistedUrlPatterns = [
    'clarity.ms',
    'connect.facebook.net',
    'facebook.com',
    'google-analytics.com',
    'google.com',
    'googleads.g.doubleclick.net',
    'googletagmanager.com',
    'jnn-pa.googleapis.com',
    'play.google.com',
    'unpkg.com',
    // Duolingo specific
    'brb.duolingo.com',
    'cdn.cookielaw.org',
    'excess.duolingo.com/batch',
    'zombie.duolingo.com',
    // IXL specific
    'cdnapisec.kaltura.com',
    'ixl.com/cookie',
    'ixl.com/liveMessage/fetchMessages',
    'pubsub.ixl.com/socket.io',
    // MathAcademy specific
    '/api/tasks/\\d+/events',
    '/api/submit-request-profile',
  ];

  static blacklistedContentTypes = [
    'application/javascript',
    'application/x-javascript',
    'application/wasm',
    'audio/',
    'binary/octet-stream',
    'application/octet-stream',
    'font/',
    'image/',
    'text/css',
    'text/javascript',
    'video/',
  ];

  static isBlacklisted(event: RequestResponseEvent): boolean {
    return Blacklist.isRequestUrlBlacklisted(event) || Blacklist.isContentTypeBlacklisted(event);
  }

  public static isRequestUrlBlacklisted(event: RequestResponseEvent): boolean {
    const requestUrl = event.request?.url;
  
    // If URL is undefined or empty, don't consider it blacklisted
    if (!requestUrl) {
      return false;
    }
    return Blacklist.blacklistedUrlPatterns.some(pattern => {
      // Check if pattern is a regex pattern (contains special characters)
      if (pattern.includes('\\d') || pattern.includes('\\w') || pattern.includes('*') || 
          pattern.includes('+') || pattern.includes('?') || pattern.includes('[')) {
        try {
          // Create a RegExp object from the pattern
          const regex = new RegExp(pattern);
          return regex.test(requestUrl);
        } catch (e) {
          console.error(`Invalid regex pattern: ${pattern}`, e);
          // Fall back to includes for invalid regex
          return requestUrl.toLocaleLowerCase().includes(pattern.toLocaleLowerCase());
        }
      }
      // Use includes for simple string patterns
      return requestUrl.toLocaleLowerCase().includes(pattern.toLocaleLowerCase());
    });
  }

  private static isContentTypeBlacklisted(event: RequestResponseEvent): boolean {
    const contentType = event.response.contentType;
    if (!contentType) {
      return false;
    }
    return Blacklist.blacklistedContentTypes.some(pattern =>
      contentType.toLocaleLowerCase().startsWith(pattern.toLocaleLowerCase())
    );
  }
}
